import "./events-listing-page.scss";

import { Page } from "modules/Page";


export class EventsListingPage extends Page<typeof EventsListingPage> {
    public static readonly className = "js-events-listing-page";

    constructor(rootElement: HTMLElement, index: number) {
        super(rootElement, index);

        this.initCategoriesTabs();
    }

    public initCategoriesTabs() {
        const categories = this.rootElement.querySelectorAll(".tab-categories > div");
        const tabButtons = this.rootElement.querySelectorAll(".tab-list li");

        // Handle tab click events
        tabButtons.forEach((tab) => {
            tab.addEventListener("click", () => {
                const isActive = tab.classList.contains("active");
                const tabId = tab.getAttribute("data-item");
                const tabContent = this.rootElement.querySelectorAll(`div[data-item="${tabId}"]`);

                if (isActive) {
                    return;
                }

                // Close all tabs
                tabButtons.forEach((otherTab) => otherTab.classList.remove("active"));
                categories.forEach((category) => category.classList.remove('active'));

                // Open clicked tab if not already active
                if (!isActive) {
                    tab.classList.add("active");
                    tabContent[0].classList.add('active');
                }
            });
        });
    }

   
}
